(function($){



     $('.hamburger').click(function(){

        $('body').toggleClass('is-locked');

         if( $(this).hasClass('active') ) {
             $(this).removeClass('active');
             $('.header .wrapper:last-child').removeClass('active');
         }
         else{
            $(this).addClass('active');
            $('.header .wrapper:last-child').addClass('active');
         }
         
     });

     function mobile_menu(x) {
        if (x.matches) { // If media query matches

            $( ".menu-item-has-children" ).each(function( index ) {

                $(this).one("click", function(event) {
                    event.preventDefault();
                    $(this).unbind('click'); 
                });

            });

            $('.menu-item-has-children').click(function(){

                if( $(this).is(':focus') || $(this).is(':hover')) {
                    
                    $(this).addClass('active');
                }
                else{
                    $(this).removeClass('active');
                }

            });

        }

        if (x.matches) {
            //console.log('hello');
            var ch = $('.header').outerHeight();
            $('.slider').css({'margin-top':ch+'px'});
            $(window).on('resize', function(){
                console.log('resizing');
                var ch = $('.header').outerHeight();
                $('.slider').css({'margin-top':ch+'px'});
            });
        }

    }

    function swiper_arrows() {
        var elements = $('.swiper-wrapper');

        elements.each(function() {
            var element = $(this);
            var count = element.contents().filter(function() {
                return this.nodeType == Node.ELEMENT_NODE || (this.nodeType == Node.TEXT_NODE && !!$.trim(this.nodeValue))
            }).length;
            if( count < 2 ) {
                $('.swiper-button-next, .swiper-button-prev').hide();
            }
            //console.log(this.id + ': ' + count)
        });

    }

        var x = window.matchMedia("(max-width: 1023px)")
        swiper_arrows()
        mobile_menu(x)
        x.addListener(mobile_menu)







})(jQuery);